import styled from 'styled-components';
import { mq } from '~/styles/grid';
import Container from '~/grid/Container';
import { TitleBasicCss } from './DescriptionDetail.JobDetail';
import { useIntl } from 'react-intl';

const Wrapper = styled.div`
  border-top: 3px solid ${(props) => props.theme.color.gray50};
  padding: 55px 0;
  width: 100%;

  @media print {
    padding: 15px 0;
  }
`;

const Heading = styled.h3`
  ${TitleBasicCss};
`;

const AttributesWrapper = styled.div`
  margin-top: 35px;
  column-count: 2;

  @media (${(props) => props.theme.jobDetail.mobileSwitch}) {
    column-count: 1;
  }

  @media print {
    column-count: 2;
    margin-top: 10px;
  }
`;

const Attribute = styled.div`
  display: flex;
  margin-bottom: 15px;

  @media (${(props) => props.theme.jobDetail.mobileSwitch}) {
    flex-wrap: wrap;
  }

  @media print {
    margin-bottom: 8px;
  }
`;

const AttributeTitle = styled.h4`
  color: ${(props) => props.theme.color.primary800};
  width: 40%;
  min-width: 40%;
  margin-right: 15px;
  break-inside: avoid;

  @media (${mq.lg}) {
    margin-right: 0;
    min-width: 50%;
    width: 50%;
  }

  @media (${(props) => props.theme.jobDetail.mobileSwitch}) {
    margin-right: 0;
    width: 100%;
  }
`;

const AttributeValue = styled.div`
  span {
    &:after {
      content: ' / ';
    }

    &:last-of-type:after {
      content: '';
    }
  }
`;

const MultipleAttributesSpan = styled.span`
  &:after {
    content: ', ' !important;
  }

  &:last-of-type:after {
    content: '' !important;
  }
`;

/**
 * @param {JobAdAttributes} props
 * @returns {React.ReactElement} The rendered component
 */
const AttributeLine = ({ title, value }) => {
  return (
    <Attribute>
      <AttributeTitle>{title}:</AttributeTitle>
      <AttributeValue>
        {value.map((item, idx) => {
          return (
            <>
              {item.length === 1 && <span key={idx}>{item}</span>}
              {item.length > 1 && (
                <span key={idx}>
                  {item.map((attr, index) => {
                    return (
                      <MultipleAttributesSpan key={index}>
                        {attr}
                      </MultipleAttributesSpan>
                    );
                  })}
                </span>
              )}
            </>
          );
        })}
      </AttributeValue>
    </Attribute>
  );
};

/**
 * @param {JobAdAttributes} props
 * @returns {React.ReactElement} The rendered component
 */
const Overview = ({ attributes, language, alternativeLanguage = '' }) => {
  const intl = useIntl();
  return (
    <Wrapper>
      <Container>
        <Heading>
          {intl.formatMessage({
            id: 'jobDetailOverviewHeadline',
          })}
        </Heading>
        <AttributesWrapper>
          {attributes.map((item, idx) => {
            return (
              <AttributeLine
                key={idx}
                title={item.title}
                value={item.value}
                language={language}
                alternativeLanguage={alternativeLanguage}
              />
            );
          })}
        </AttributesWrapper>
      </Container>
    </Wrapper>
  );
};

export default Overview;
